import React, { useId, useLayoutEffect, useRef, useState } from "react";

/** Collapse navigation without unmounting the active KDS or its slot controls. */
export default function KdsTabsCollapse({ enabled, collapsed, onToggle, children }) {
  const contentRef = useRef(null);
  const [contentWidth, setContentWidth] = useState(null);
  const contentId = useId();

  useLayoutEffect(() => {
    if (!enabled) return;
    const content = contentRef.current;
    const measure = () => {
      const width = content?.getBoundingClientRect().width;
      if (width > 0) setContentWidth(width);
    };
    measure();
    const observer = typeof ResizeObserver === "function" ? new ResizeObserver(measure) : null;
    if (content) observer?.observe(content);
    window.addEventListener("resize", measure);
    return () => {
      observer?.disconnect();
      window.removeEventListener("resize", measure);
    };
  }, [enabled, collapsed]);

  if (!enabled) return children;
  return (
    <div className={`kds-tabs-navigation${collapsed ? " is-collapsed" : ""}`}>
      <div
        id={contentId}
        className="kds-tabs-clip"
        style={{ width: contentWidth ?? "max-content" }}
      >
        <div className="kds-tabs-content" ref={contentRef}>{children}</div>
      </div>
      <button
        type="button"
        className="kds-tabs-toggle"
        onClick={onToggle}
        aria-label={collapsed ? "Expand screen tabs" : "Collapse screen tabs"}
        aria-expanded={!collapsed}
        aria-controls={contentId}
        title={collapsed ? "Expand screen tabs" : "Collapse screen tabs"}
      >
        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor"
          strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
          <path d="m14 6-6 6 6 6" />
        </svg>
      </button>
    </div>
  );
}
